export default __webpack_public_path__ + "static/media/Gillette.5540f546.svg";